import React, { useEffect, useState, useRef } from 'react';
import { throttle } from '@library/Utils';

const ScrollTopBtn = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;

    if (scrollTop >= 50) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const throttledFn = useRef(throttle(handleScroll, 500));

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', throttledFn.current);

    return () => {
      window.removeEventListener('scroll', throttledFn.current);
    };
  }, []);

  return (
    isVisible && (
      <button type="button" id="btnTop" className="btn-scroll-top" onClick={scrollToTop}>
        최상단으로 이동
      </button>
    )
  );
};

export default ScrollTopBtn;
